var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "addRound",
    "data-name": "addRound",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "addRound-1",
    d: "M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "addRound-1",
    x: 120.5,
    y: 45.58,
    width: 15,
    height: 164.83
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "addRound-1",
    x: 120.5,
    y: 45.58,
    width: 15,
    height: 164.83,
    transform: "translate(256 0) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddRound);
export default __webpack_public_path__ + "static/media/icon-add-round.01765497.svg";
export { ForwardRef as ReactComponent };